import React, { Component } from 'react';
import PropTypes from 'prop-types';
import deepEqual from 'deep-equal';

import VideoList from '../../app/bento-components/video-list/video-list';
import { parseVideo, getPageCount } from '../../app/bento-components/video-list/video-utils';
import {
	CAROUSEL_ITEMS_PER_PAGE,
	ITEMS_PER_PAGE,
	PAGINATION_TYPES
} from '../../app/bento-components/video-list/metadata';
import VideoCTA from './video-list-cta';
import { getVideos } from './ajax';
import { ALL_SEASONS } from './constants';
import {arraysEqual} from "../../app/utils";

const htmlTag = document.querySelectorAll('html')[0];

const SMALL_BREAKPOINT_PX = 767;

class VideoListHOCFE extends Component {
    static propTypes = {
        id: PropTypes.string.isRequired,
        columnSize: PropTypes.number.isRequired,
        linkWidget: PropTypes.node,
        data: PropTypes.object.isRequired,
        API: PropTypes.object.isRequired,
        settings: PropTypes.shape({
            selectedSeasonFilter: PropTypes.object,
            selectedShows: PropTypes.arrayOf(
                PropTypes.shape({
                    id: PropTypes.string.isRequired,
                    title: PropTypes.string.isRequired
                })
            ),
            selectedSeasons: PropTypes.arrayOf(
                PropTypes.shape({
                    label: PropTypes.string.isRequired,
                    value: PropTypes.string.isRequired
                })
            ),
            itemsPerPage: PropTypes.number.isRequired,
            displayVideoTitle: PropTypes.bool.isRequired,
            displayShowTitle: PropTypes.bool.isRequired,
            displayVideoDescription: PropTypes.bool.isRequired,
            displayVideoMeta: PropTypes.bool.isRequired,
            videoType: PropTypes.string.isRequired,
            paginationType: PropTypes.string.isRequired,
            order: PropTypes.shape({
                value: PropTypes.string.isRequired,
                title: PropTypes.string.isRequired
            }),
            player: PropTypes.shape({
                autoplay: PropTypes.bool.isRequired,
                topbar: PropTypes.bool.isRequired
            }),
            selectedRegions: PropTypes.array
        }),
        callsign: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.state = {
            videos: [],
            pageCount: 0,
            currentVideo: {},
            overlayVideo: false,
            showVideo: false,
            currentPage: 1,
            settings: props.settings,
            isLoadMoreEnabled: false,
            selectedSeasonFilter: ALL_SEASONS,
            videoChangeAnnouncement: ''
        };

        this.init = this.init.bind(this);
        this.videoClick = this.videoClick.bind(this);
        this.videoClose = this.videoClose.bind(this);
        this.onResize = this.onResize.bind(this);
        this.setCurrentPage = this.setCurrentPage.bind(this);
        this.showLoading = this.showLoading.bind(this);
        this.getVideosCallback = this.getVideosCallback.bind(this);
        this.isSmallBreakpoint = window.matchMedia(`(max-width: ${SMALL_BREAKPOINT_PX}px)`).matches;
    }

    componentDidMount() {
        const {
            settings: { selectedShows, selectedRegions },
            settings,
            API
        } = this.props;
        let params = {
            ...settings
        };

        if (selectedRegions)
            params.selectedRegions = selectedRegions.map(({ value }) => value).join(',');
            params.itemsPerPage = this.isSmallBreakpoint ? CAROUSEL_ITEMS_PER_PAGE : ITEMS_PER_PAGE.max
            params.paginationType = this.isSmallBreakpoint ? PAGINATION_TYPES.CAROUSEL : settings.paginationType;

        if (selectedShows.length) {
            getVideos(API, params, this.showLoading).done(this.init);
        }

        window.addEventListener('resize', this.onResize, false);

        if (this.isSmallBreakpoint) {
            this.setState({
                selectedSeasonFilter: ALL_SEASONS,
                settings: {
                    ...this.state.settings,
                    paginationType: PAGINATION_TYPES.CAROUSEL,
                    itemsPerPage: CAROUSEL_ITEMS_PER_PAGE
                },
                videos: []
            });
        } else{
            this.setState({
                selectedSeasonFilter: ALL_SEASONS
            });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            settings: {
                selectedShows,
                seasonFilter,
                selectedSeasons,
                itemsPerPage,
                videoType,
                order,
                paginationType,
                includePassportVideos,
                selectedRegions
            },
						API
        } = this.props;

        // if something changes in selected shows, season filter toggle or
        // selected seasons, reset the frontend season filter
        if (
            (!arraysEqual(selectedShows, prevProps.settings.selectedShows) ||
                seasonFilter !== prevProps.settings.seasonFilter ||
                (selectedSeasons &&
                    !arraysEqual(prevProps.settings.selectedSeasons, selectedSeasons))) &&
            this.state.selectedSeasonFilter.value !== ALL_SEASONS.value
        ) {
            this.setState({
                selectedSeasonFilter: ALL_SEASONS
            });
        }

        // when pagination type changes from carousel to other type itemsPerPage also changes
        if (
            paginationType !== prevProps.settings.paginationType &&
            (paginationType == PAGINATION_TYPES.CAROUSEL ||
                prevProps.settings.paginationType === PAGINATION_TYPES.CAROUSEL)
        ) {
            this.setState({
                videos: [],
                currentVideo: {},
                pageCount: 0,
                overlayVideo: false,
                showVideo: false,
                currentPage: 1
            });
            return;
        }

        // if something changes in getVideos filters, reset the current page
        if (
            (!arraysEqual(selectedShows, prevProps.settings.selectedShows) ||
                !arraysEqual(selectedSeasons, prevProps.settings.selectedSeasons) ||
                seasonFilter !== prevProps.settings.seasonFilter ||
                this.state.selectedSeasonFilter !== prevState.selectedSeasonFilter ||
                itemsPerPage !== prevProps.settings.itemsPerPage ||
                videoType !== prevProps.settings.videoType ||
                !deepEqual(order, prevProps.settings.order) ||
                paginationType !== prevProps.settings.paginationType ||
                includePassportVideos !== prevProps.settings.includePassportVideos ||
                selectedRegions !== prevProps.settings.selectedRegions) &&
            this.state.currentPage !== 1
        ) {
            this.setState({ currentPage: 1 });
            return;
        }

        if (
            !arraysEqual(selectedShows, prevProps.settings.selectedShows) ||
            !arraysEqual(selectedSeasons, prevProps.settings.selectedSeasons) ||
            seasonFilter !== prevProps.settings.seasonFilter ||
            this.state.selectedSeasonFilter !== prevState.selectedSeasonFilter ||
            itemsPerPage !== prevProps.settings.itemsPerPage ||
            this.state.currentPage !== prevState.currentPage ||
            videoType !== prevProps.settings.videoType ||
            !deepEqual(order, prevProps.settings.order) ||
            paginationType !== prevProps.settings.paginationType ||
            includePassportVideos !== prevProps.settings.includePassportVideos ||
            selectedRegions !== prevProps.settings.selectedRegions
        ) {
            // load videos if there is a selected show, all other filters have default values
            if (selectedShows.length) {
                let params = {
                    ...this.state.settings,
                    page: this.state.currentPage
                };

                if (this.state.selectedSeasonFilter && this.state.selectedSeasonFilter.value) {
                    params.seasonId = this.state.selectedSeasonFilter.value;
                    params.selectedShows = [];
                }
                // disable Load More button while loading videos
                if(this.state.isLoadMoreEnabled) {
                    if (paginationType === PAGINATION_TYPES.LOAD_MORE || paginationType === PAGINATION_TYPES.CAROUSEL) {
                        this.setState({isLoadMoreEnabled: false});
                    }
                }
                let isReset = this.state.currentPage === 1;
                getVideos(API, params, () => this.showLoading(isReset)).done(
                    this.getVideosCallback
                );
            } else {
                // 	if Show filter is empty/reset, reset state
                this.setState({
                    videos: [],
                    currentVideo: {},
                    pageCount: 0,
                    overlayVideo: false,
                    showVideo: false,
                    currentPage: 1
                });
            }
        }
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.onResize);
    }

    onResize(){
        this.isSmallBreakpoint = window.matchMedia(`(max-width: ${SMALL_BREAKPOINT_PX}px)`).matches;
        let paginationType = this.isSmallBreakpoint ? PAGINATION_TYPES.CAROUSEL : this.props.settings.paginationType;
        let itemsPerPage = this.isSmallBreakpoint ? CAROUSEL_ITEMS_PER_PAGE : ITEMS_PER_PAGE.max
        if (this.state.settings.paginationType !== paginationType) {
            this.setState({
                settings: {
                    ...this.state.settings,
                    paginationType,
                    itemsPerPage
                }
            });
            this.setCurrentPage(1);
        }
    }

    init(response) {
        const videos = response.data.map((video) => parseVideo(video));
        this.setState((state, props) => {
            return {
                videos: videos,
                pageCount: getPageCount(response),
                currentVideo: videos[0],
                isLoadMoreEnabled: props.settings.paginationType === PAGINATION_TYPES.LOAD_MORE
            };
        });
    }

    videoClick(e, video) {
        e.preventDefault();
        const { overlayVideo } = this.state;
        this.setState({
            currentVideo: video,
            showVideo: true,
            videoChangeAnnouncement: `Now playing: ${video.videoTitle || video.title || ''}`
        });
        if (overlayVideo) {
            htmlTag.classList.add('modal-open');
        }
    }

    videoClose(e) {
        this.setState({
            showVideo: false
        });
        htmlTag.classList.remove('modal-open');
    }

    setCurrentPage = (pageNumber) => {
        let pageCount = Math.max(1, this.state.pageCount);
        const validPage = Math.min(Math.max(1, pageNumber), pageCount);
        this.setState({
            currentPage: validPage
        });
    };

    getVideosCallback = (response) => {
        const {
            settings: { itemsPerPage }
        } = this.props;

        let newState = {};
        let isInit = this.state.currentPage === 1;
        let paginationType = this.isSmallBreakpoint ? PAGINATION_TYPES.CAROUSEL : this.props.settings.paginationType;

        if (paginationType === PAGINATION_TYPES.LOAD_MORE) {
            if (isInit) {
                newState.videos = response.data.map((video) => parseVideo(video));
                newState.currentVideo = newState.videos[0];
            } else {
                let videos = this.state.videos.slice(0, -itemsPerPage);
                newState.videos = videos.concat(response.data.map((video) => parseVideo(video)));
            }
            newState.isLoadMoreEnabled = true;
        }

        if (paginationType === PAGINATION_TYPES.CAROUSEL) {
            let videos = this.state.videos;
            newState.videos = videos.concat(response.data.map((video) => parseVideo(video)));
            if (isInit) {
                newState.videos = [...response.data.map((video) => parseVideo(video))];
                newState.currentVideo = newState.videos[0];
            }
        }

        if (paginationType === PAGINATION_TYPES.PAGINATION) {
            newState.videos = [...response.data.map((video) => parseVideo(video))];
            if (isInit) {
                newState.currentVideo = newState.videos[0];
            }
        }

        this.setState({
            ...newState,
            pageCount: getPageCount(response)
        });
    };

    showLoading = (reset = false) => {
        const {
            settings: { itemsPerPage, paginationType }
        } = this.state;
        const { videos } = this.state;
        let isLoadMoreEnabled = true;
        let newVideos;

        if (paginationType === PAGINATION_TYPES.CAROUSEL) {
            return;
        }

        if (paginationType === PAGINATION_TYPES.LOAD_MORE && !reset) {
            newVideos = [...videos, ...Array(itemsPerPage).fill({})];
            isLoadMoreEnabled = false;
        } else {
            newVideos = Array(itemsPerPage).fill({});
        }

        this.setState({
            videos: newVideos,
            isLoadMoreEnabled
        });
    };

    handleSelectSeasonFilter = (season) => {
        const { settings, API } = this.props;

        let params = {
            ...settings
        };

        let isLoadMoreEnabled = false;

        if (settings.selectedRegions)
            params.selectedRegions = settings.selectedRegions
                .map(({ value }) => value)
                .join(',');

        params.page = 1;
        if (season.value) {
            params.seasonId = season.value;
            params.selectedShows = [];
        }

        this.setState({
            videosHasChanged: false,
            selectedSeasonFilter: season
        });

        getVideos(API, params, this.showLoading).done((response) => {
            let newVideos = [...response.data.map((video) => parseVideo(video))];
            let pageCount = getPageCount(response);
            if (params.paginationType === PAGINATION_TYPES.PAGINATION) {
                isLoadMoreEnabled = true;
            }
            this.setState({
                currentPage: 1,
                videos: newVideos,
                pageCount: pageCount,
                isLoadMoreEnabled: isLoadMoreEnabled,
                selectedSeasonFilter: season
            });
        });
    };

    render() {
        const {
            videos,
            pageCount,
            currentVideo,
            showVideo,
            overlayVideo,
            currentPage,
            isLoadMoreEnabled,
            selectedSeasonFilter,
            videoChangeAnnouncement
        } = this.state;

        const { data, id, columnSize, callsign, site } = this.props;
        const VideoListTitle = () => (
            <h1 className="video-list-title">{data.title || data.titlePlaceholder}</h1>
        );

        return (
            <div className="bento-component" role="region" aria-label="Video List Component">
                {/* Screen-reader-only live region for loading state */}
                <div
                    className="sr-only"
                    aria-live="assertive"
                    aria-atomic="true"
                    role="status">
                    {videoChangeAnnouncement
                        ? videoChangeAnnouncement
                        : videos.length === 0
                            ? 'Loading videos…'
                            : `${videos.length} video${videos.length !== 1 ? 's' : ''} loaded`}
                </div>
                <VideoList
                    {...this.props}
                    columnSize={columnSize}
                    videos={videos}
                    settings={this.state.settings}
                    data={data}
                    pageCount={pageCount}
                    currentPage={currentPage}
                    setCurrentPage={this.setCurrentPage}
                    componentId={id}
                    CallToAction={VideoCTA}
                    currentVideo={currentVideo}
                    videoClick={this.videoClick}
                    videoClose={this.videoClose}
                    VideoListTitle={VideoListTitle}
                    showVideo={showVideo}
                    playerClass={overlayVideo ? 'overlay' : ''}
                    isLoadMoreEnabled={isLoadMoreEnabled}
                    callsign={callsign}
                    currentSite={{ isPillButtonAvailable: site.is_pill_button_available }}
                    handleSelectSeasonFilter={this.handleSelectSeasonFilter}
                    selectedSeasonFilter={selectedSeasonFilter}
                />
            </div>
        );
    }
}

export default VideoListHOCFE;
